<template>
  <section class="magazine-highlights">
    <div class="magazine-highlights__wrapper">
      <CardMagazineHighlights image="christmas-highlight-1.jpg"/>
    </div>
    <!-- <div class="magazine-highlights__wrapper">
      <CardMagazineHighlights image="christmas-highlight-2.jpg"/>
    </div> -->
  </section>
</template>

<script>
import CardMagazineHighlights from '@/components/CardMagazineHighlights.vue'
export default {
  name: 'MagazineHighlights',
  components: {
    CardMagazineHighlights
  }
}
</script>

<style lang="postcss">
.magazine-highlights {
  @apply -mx-4 pt-0 pb-4 flex flex-wrap sticky z-10;
   top:90px;
}
.magazine-highlights__wrapper {
  @apply px-4 w-full;
}
@screen sm {
  .magazine-highlights {
    @apply flex-no-wrap;
  }
  .magazine-highlights__wrapper {
    @apply flex-1;
  }
}
@screen md {
  .magazine-highlights {
  @apply pt-2;
}
}
@screen lg {
  .magazine-highlights {
  @apply pt-4;
}
}
</style>
